import QueryString from "qs";
import { useMemo } from "react";

export default function useSearchs<T extends Record<string, any>>(): T {
  const search = useMemo(() => {
    const searchStr = window.location.search.slice(1);
    const res = QueryString.parse(searchStr);
    const result: T = {} as T;
    Object.keys(res).forEach((key) => {
      const value = res[key];
      if (Array.isArray(value)) {
        // @ts-ignore
        result[key] = value[0];
      } else {
        // @ts-ignore
        result[key] = value;
      }
    });
    return result;
  }, [window.location.search]);

  return search;
}
